import {Component, Input} from '@angular/core';

@Component({
  selector: 'myvf-ui-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() show: boolean;
  @Input() text: string;
}
